<template>
  <div class="auth-box-w">
    <div class="logo-w">
      <a href="#"><img alt="Wave" src="../../assets/img/wave_logo.png" width="100"/></a>
    </div>
    <h4 class="auth-header text-xl">{{ $t('Login') }}</h4>
    <form role="form" data-toggle="validator" @submit.prevent="submit">
      <div>
        {{ $t('Logging in as {sessionName}', { sessionName: payload.sessionName }) }}
      </div>
      <q-list v-if="payload.profiles.length" class="q-mt-md">
        <q-item tag="label" v-for="profile in payload.profiles" :key="profile.token" v-ripple>
          <q-item-section avatar top>
            <q-radio v-model="selectedToken" :val="profile.token" />
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ profile.userId }}</q-item-label>
            <q-item-label caption>{{ profile.roles.join(', ') }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
      <div class="q-mt-md">
        <Button
          v-if="payload.profiles.length"
          color="primary"
          nativeType="submit"
          long
          :loading="loading"
        >
          {{ $t('Login') }}
        </Button>
      </div>
    </form>
    <div class="text-right text-1 p-2">
      <el-dropdown trigger="click" @command="handleChangeLang" class="float-left">
        <span class="el-dropdown-link">
          <i class="fa fa-globe-americas mr-1"></i>
          <i class="fa fa-chevron-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="en">English</el-dropdown-item>
          <el-dropdown-item command="ja">日本語</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <p />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Cookies from 'js-cookie';
import Config from '@/config';
import Button from '@/components/uikit/Button';

const messages = {
  en: {
    Login: 'Login',
    'Logging in as {sessionName}': 'Logging in as {sessionName}',
  },
  ja: {
    Login: 'ログイン',
    'Logging in as {sessionName}': '{sessionName} としてログイン中',
  },
};

export default {
  name: 'SamlLogin',
  i18n: { messages },
  components: { Button },
  data() {
    return {
      payload: {},
      selectedToken: '',
      loading: false,
    };
  },
  created() {
    const { payload } = this.$route.query;
    const { idp_id: idpId, profiles, session_name: sessionName } = JSON.parse(atob(payload));
    this.payload = {
      idpId,
      profiles: profiles.map(item => ({
        userId: item.user_id,
        roles: item.roles,
        token: item.token,
      })),
      sessionName,
    };
    this.selectedToken = this.payload.profiles[0].token;
  },
  computed: {},
  methods: {
    ...mapActions('auth', {
      getAccessTokenViaSaml: 'getAccessTokenViaSaml',
    }),
    setTokenCookie(token) {
      Cookies.set('mo_access_token', token, {
        expires: Config.tokenExpire,
        path: Config.cookiePath,
      });
    },
    handleChangeLang(value) {
      Cookies.set('mo-wave-locale', value, {
        expires: 300,
      });
      this.$i18n.locale = value;
      this.$validator.localize(value);
      localStorage.setItem('temporaryLanguage', value);
    },
    async submit() {
      this.loading = true;
      try {
        const token = await this.getAccessTokenViaSaml({ token: this.selectedToken });
        await this.setTokenCookie(token);
        await this.$root.loadInitialData('login');
      } catch (err) {
        console.log(err);
        if (err === 'API connection error: Can not access to API.') {
          this.$message({
            message: this.$t('API connection error: Can not access to API.'),
            type: 'error',
          });
        } else {
          this.$message({ message: this.$t('Error Occurred'), type: 'error' });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
